export function isDev(): boolean {
  try {
    return typeof process !== 'undefined' && (process.env?.NODE_ENV === 'development');
  } catch {
    return false;
  }
}

export default isDev;
